import { EventInterface } from '@splidejs/splide';

export default function SplideNacFade( Splide, Components ) {
  const { bind } = EventInterface( Splide );
  const { Move } = Components;
  const { list } = Components.Elements;

  let endCallback;

  function mount() {
    // bind( list, 'transitionend', e => {
    //   if ( e.target === list && endCallback ) {
    //     // Removes the transition property
    //     cancel();

    //     // Calls the `done` callback
    //     endCallback();
    //   }
    // } );
    // sometimes on "mount" it trigger also "resize" event, sometimes dont, so we have to do apply translate3d twice
			Splide.on('resize', function() {
				Array.prototype.forEach.call( Components.Elements.slides, function(slide, i) {
					slide.style.transform = `translate3d(-`+ Components.Elements.list.clientWidth * i +`px, 0px, 0px)`;
				});
			});

			Array.prototype.forEach.call( Components.Elements.slides, function(slide, i) {
				slide.style.opacity = ( Splide.index >= i ) ? 1 : 0;
				slide.style.transform = `translate3d(-`+ Components.Elements.list.clientWidth * i +`px, 0px, 0px)`; 
        // slide.style.transform = 'scale(125)';
				// if( Splide.index === i-1 )
				// 	slide.style.zIndex = 1;
        if( Splide.index === i )
            slide.style.zIndex = 2;
			});
  }

  function start( index, done ) {
  // function start( destIndex, newIndex, prevIndex, coord, done ) {

    // // Converts the index to the position
    // const destination = Move.toPosition( index, true );
    // console.log('start', index, done, destination);

    // // Applies the CSS transition
    // // list.style.transition = 'transform 800ms cubic-bezier(.44,.65,.07,1.01)';
    // list.style.transition = 'opacity 600ms cubic-bezier(.44,.65,.07,1.01)';
    // // list.classList.add('opacity-100');

    // // Moves the carousel to the destination.
    // Move.translate( destination );

    // // Keeps the callback to invoke later.
    // endCallback = done;

    setTimeout(function() {
      done();
    })

    Array.prototype.forEach.call( Components.Elements.slides, function(slide, i) {
      slide.style.transition = `opacity ${ Splide.options.speed }ms ease 0s`;
      slide.style.opacity = ( index >= i ) ? 1 : 0;
      slide.style.zIndex = 'inherit';
      // slide.style.transform = 'scaleX("125%") scaleY("125%")'
    });
  }

  function cancel() {
    list.style.transition = '';
  }

  return {
    mount,
    start,
    cancel,
  };
}